import React from 'react';
import { Link } from 'react-router-dom';

// Internal
import Typography from '../components/Typography';
import { signInWithGoogle, registerWithEmailAndPassword } from '../services/firebase';

// Antd
import { Form, Input, Button, Space } from 'antd';

// Icons
import { Mail, Key } from 'react-feather';

// Styles
import styles from './login.module.scss';

// MISC
import GOOGLE from '../img/pages/login/google.svg';

function Register() {
  const onFinish = (values: any) => {
    registerWithEmailAndPassword(values.email, values.password);
  };

  return (
    <>
      <Space direction="vertical" className={styles.loginPage__container__form__methods}>
        <Typography type="display_md" weight="semibold">
          Sign up
        </Typography>

        <Typography type="text_md" color="secondary">
          Let’s set up your account.
        </Typography>

        <Form onFinish={onFinish}>
          {/* <Form.Item
          name="name"
          rules={[
            { required: true, message: 'Missing full name' }
          ]}
        >
          <Input prefix={<UserOutlined />} placeholder="Full name" size="large" />
        </Form.Item> */}

          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Missing email address' },
              { type: 'email', message: 'Invalid email address' },
            ]}
          >
            <Input prefix={<Mail />} placeholder="Email address" size="large" />
          </Form.Item>

          <Form.Item name="password" rules={[{ required: true, message: 'Missing password' }]}>
            <Input prefix={<Key />} type="password" placeholder="Password" size="large" />
          </Form.Item>

          <Button type="primary" htmlType="submit" size="large">
            Create account
          </Button>

          {/* <Button onClick={signInWithGoogle} size="large" style={{ marginTop: '1rem' }}>
            <img src={GOOGLE} /> Sign up with Google
          </Button> */}
        </Form>

        <div className={styles.loginPage__container__form__signup__message}>
          <Typography type="text_sm" color="secondary">
            Already have an account? <Link to="/">Login</Link> now.
          </Typography>
        </div>
      </Space>
    </>
  );
}
export default Register;
